module.exports = __webpack_public_path__ + "static/media/Portrait-10257.17d8275c.jpg";